// src/components/TawkToWidget.js
import { useEffect } from "react";

function TawkToWidget() {
    useEffect(() => {
        // Define globals safely
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        // Create script element
        const s1 = document.createElement("script");
        s1.async = true;
        s1.src = "https://embed.tawk.to/68c9d7a136521a19259e944c/1j5a74kls";
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");

        // Append before first script tag
        const s0 = document.getElementsByTagName("script")[0];
        s0.parentNode.insertBefore(s1, s0);

        return () => {
            // Cleanup if component unmounts (optional)
            s1.remove();
        };
    }, []);

    return null;
}

export default TawkToWidget;
